module.exports = __webpack_public_path__ + "img/1.fc9c9737.png";